import Modal from "@via/components/modal.tsx";
import { ButtonColor } from "@via/utils/constants.tsx";
import { GetUserGroupsResponse } from "common";
import { type FC } from "react";
import { useDeleteUserGroup } from "@via/api/user-groups.api.tsx";

type DeleteUserGroupModalProps = {
  userGroup: GetUserGroupsResponse;
  setUserGroupToBeDeleted: (userGroup: GetUserGroupsResponse | null) => void;
};

const DeleteUserGroupModal: FC<DeleteUserGroupModalProps> = ({
  userGroup,
  setUserGroupToBeDeleted,
}) => {
  const { mutateAsync: deleteUserGroup, isPending: isDeleteUserGroupLoading } =
    useDeleteUserGroup();

  const handleDeleteUserGroup = async (id: string): Promise<void | boolean> => {
    // Returning false keeps the dialog open. Resolving closes it through Modal's
    // setOpen, which is what clears the row being deleted, so there is one close
    // path rather than a success effect racing the dialog.
    if (!id) return false;
    await deleteUserGroup(id);
  };

  return (
    <Modal
      open={!!userGroup}
      setOpen={() => {
        setUserGroupToBeDeleted(null);
      }}
      title="Delete User Group"
      confirmText="Delete"
      confirmButtonColor={ButtonColor.Red}
      isConfirmLoading={isDeleteUserGroupLoading}
      onConfirm={() => handleDeleteUserGroup(userGroup.id.toString())}>
      <div className="flex flex-col py-2 text-sm leading-6 text-slate-600 md:py-3 lg:py-4">
        <p>
          Are you sure you want to delete user group{" "}
          <span className="font-semibold">{userGroup?.name}</span>?
        </p>
      </div>
    </Modal>
  );
};

export default DeleteUserGroupModal;
